import { render, staticRenderFns } from "./ReportScoreByAll.vue?vue&type=template&id=c2be14d2"
import script from "./ReportScoreByAll.vue?vue&type=script&lang=js"
export * from "./ReportScoreByAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports